import React from "react";

const FormElement = (props) => {
  const {children, label} = props;
  return (
    <div {...props} className="formElement">
      <div>{label}</div>
      {children}
    </div>
  );
};

export default FormElement;